import { useEffect, useState, useRef, useCallback } from "react";

const useElementSize = (setElementSize) => {
  const [height, setHeight] = useState();
  const [width, setWidth] = useState();
  const ref = useRef();
  const setElementRef = useCallback((element) => (ref.current = element), []);

  useEffect(() => {
    if (ref.current) {
      const callback = (entries) => {
        entries.forEach((entry) => {
          if (entry.borderBoxSize?.[0]) {
            const newHeight = entry.borderBoxSize[0].blockSize;
            const newWidth = entry.borderBoxSize[0].inlineSize;

            if (height !== newHeight || width !== newWidth) {
              setElementSize({
                height: newHeight,
                width: newWidth,
              });

              setHeight(newHeight);
              setWidth(newWidth);
            }
          }
        });
      };

      try {
        const observer = new ResizeObserver(callback);
        observer.observe(ref.current);

        return () => observer.disconnect();
      } catch (error) {
        // No Resize Observer
      }
    }
  }, [ref, setElementSize]);

  return setElementRef;
};

export default useElementSize;
